/**
 * @generated SignedSource<<c8168759babe955bd7f478a7641d7474>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserEditForm_user$data = {
  readonly canPublish: boolean;
  readonly email: string;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "UserEditForm_user";
};
export type UserEditForm_user$key = {
  readonly " $data"?: UserEditForm_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserEditForm_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserEditForm_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canPublish",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "46cbf40b465de951d9e5c172d9dd69cd";

export default node;
